import React, { useState } from 'react';
import { Text, Box } from 'braid-design-system';
import { useTranslations } from '@vocab/react';
import { observer } from 'mobx-react';
import TextButton from 'src/components/common/TextButton';
import { CertsyCredentialDetailWrapper } from './Credentials/CertsyCredentialDetailWrapper';
import translations from './.vocab';
import * as styles from './CertsyMoreInfo.css';
import { VerificationInfoItemList } from 'src/components/common/Certsy/VerificationInfoItemList';
import type { Verification } from 'src/App/AppPageBlock/graphql/cm-types.generated';

const TOGGLE_CONTENT_ID = 'toggle-verification-content';

export const CertsyVerifications = ({ verifications }: Props) => (
  <Box>
    {verifications.map((verification, index) => (
      <CertsyCredentialDetailWrapper
        certsyTitle={verification.title}
        key={index}
      >
        <VerificationInfoItemList
          verificationInfo={verification.credentialInfo}
        />
      </CertsyCredentialDetailWrapper>
    ))}
  </Box>
);

interface Props {
  verifications: Verification[];
}

export const CertsyMoreInfoWithVerifications = observer(
  ({ verifications }: Props) => {
    const { t } = useTranslations(translations);
    const [expanded, setExpanded] = useState(false);
    const toggle = React.useCallback(
      () => setExpanded((state) => !state),
      [setExpanded],
    );

    return (
      <Box className={styles.certsyMoreInfoContainer}>
        <Box marginBottom="large" id={TOGGLE_CONTENT_ID} hidden={!expanded}>
          <CertsyVerifications verifications={verifications} />
        </Box>
        <Text>
          <TextButton
            data-testid={`${expanded ? 'hide' : 'show'}-verification`}
            onClick={toggle}
            aria-expanded={expanded}
            aria-controls={TOGGLE_CONTENT_ID}
          >
            {t('Show verification details', {
              showDetails: expanded ? 'true' : 'other',
            })}
          </TextButton>
        </Text>
      </Box>
    );
  },
);
